const splitter = require("split-sms");

export function sliceMessageIntoParts(smsBody = "") {
  const splitObject = splitter.split(smsBody);
  return splitObject.parts.map((part) => part.content);
}
